import React, { Component } from "react";
import { CircularProgress, Typography } from "@mui/material";
import ImageMediaCard from './ImgMediaCard';

class BrandAmbassador extends Component {
    state = {
        loading: true,
        ambassadors: null,
        hasError: false
    };
    ambassadorCode = this.props.match.params.brandAmbassadorCode.toUpperCase();
    componentDidMount() {
        const url = process.env.REACT_APP_BA_URL;

        fetch(url)
        .then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                this.setState({loading: false, hasError: true});
            }
        })
        .then((responseJson) => {
            this.setState({loading: false, ambassadors: responseJson.ambassadors})
        })
        .catch((error) => {
            this.setState({loading: false, hasError: true});
        });
    }
    render() {

        if(this.state.loading) {
            return <CircularProgress className="loading" />
        }

        if(this.state.hasError){
            return <Typography variant="p" className="centered">Server error. Please try again later.</Typography>;
        }

        if(!this.state.ambassadors) {
            return <Typography variant="p" className="centered">Didn't get ambassadors</Typography>;
        }

        const isAmbassador = p => p.code === this.ambassadorCode;
        var ambassador = this.state.ambassadors.find(isAmbassador);
        if(!ambassador){
            return <Typography variant="p" className="centered">Ambassador NOT FOUND!</Typography>;
        }

        if(ambassador) {
            return (
                <ImageMediaCard ambassador={ambassador} />
            );
        }
    }
}

export default BrandAmbassador;